var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-fullheight-with-navbar",attrs:{"id":"app"}},[_c('publicNav'),_c('userNav'),_c('router-view',{key:_vm.$route.fullPath}),_c('myDialog'),_c('myLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }